export const HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
export const HLS_PATHS = /\/hls\//i;
export const DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
export const VIDEO_EXTENSIONS = /\.(mp4|webm|ogg|avi|mov|wmv|flv|mkv)($|\?)/i;
export const AUDIO_EXTENSIONS = /\.(mp3|wav|ogg|aac|wma|flac|m4a)($|\?)/i;

export const canPlay = {
  hls: (url: string): boolean => {
    if (!url || typeof url !== "string") return false;
    return HLS_EXTENSIONS.test(url) || HLS_PATHS.test(url);
  },

  dash: (url: string): boolean => {
    if (!url || typeof url !== "string") return false;
    return DASH_EXTENSIONS.test(url);
  },

  video: (url: string): boolean => {
    if (!url || typeof url !== "string") return false;
    return VIDEO_EXTENSIONS.test(url);
  },

  audio: (url: string): boolean => {
    if (!url || typeof url !== "string") return false;
    return AUDIO_EXTENSIONS.test(url);
  },

  file: (url: string): boolean => {
    if (!url || typeof url !== "string") return false;
    return VIDEO_EXTENSIONS.test(url) || AUDIO_EXTENSIONS.test(url);
  },
};
